var map = {
	".": 793,
	"./": 793,
	"./courses": 79,
	"./courses.css": 654,
	"./courses.json": 79,
	"./images/django-rest.jpg": 997,
	"./images/django-the-practical-guide.jpg": 468,
	"./images/react-advanced.jpeg": 38,
	"./images/react-basics.jpeg": 46,
	"./index": 793,
	"./index.jsx": 793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 267;